import React from 'react';
import PropTypes from 'prop-types';

import { SummaryDetail, SummaryCategory, SummaryGroupWrapper } from './css';

const FormSummaryRow = ({ label, value }) =>
  (!!value || typeof value === 'number') && (
    <SummaryGroupWrapper style={!label ? { gridTemplateColumns: '1fr' } : undefined}>
      {!!label && (
        <SummaryCategory>
          <span className="frg-body-font-14px">{label}</span>
        </SummaryCategory>
      )}
      <SummaryDetail>
        <span className="frg-body-font-14px">{Array.isArray(value) ? value.join(", ") : value}</span>
      </SummaryDetail>
      <div className="clear" />
    </SummaryGroupWrapper>
  );

FormSummaryRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

FormSummaryRow.defaultProps = {
  value: ''
};

export default FormSummaryRow;
